import { useMemo } from "react";
import {
  getSortOthersData,
  getObjectData,
  getArrayData,
} from '../utils';
import { getArraySort } from '@gp/utils/common';

import type { MilestoneDateStatus } from '@gp/enums/milestone';

type StrArrValObj = {[keyName: string]: string[]};
type ResType = {
  devProjectCount: {[keyName: string]: number} | null,
  yearProjectCount: {
    'total': number,
    'list': {
      'business_owner': string,
      'cover': string,
      'develop_id': string,
      'entity_type': string,
      'id': string,
      'launch_date_confirm': MilestoneDateStatus,
      'launch_time': string,
      'name': string,
      'publish_id': string,
    }[],
  } | null,
  businessOwner: StrArrValObj | null,
  status: StrArrValObj | null,
  platform: StrArrValObj | null,
  genre: StrArrValObj | null,
  dataTime: string;
};

const FIXED_KEY_MAP: {[keyName: string]: number} = {
  'amplifier': 0,
  'astra': 0,
  'fuel': 0,
  'nexus': 0,
  'saturn': 0,
  'solar': 0,
  'others': 0,
};

export default function (props: {
  loading: boolean,
  data: IStudioOverallProjectsKeyMetricsData | undefined,
}) {
  const {
    loading,
    data,
  } = props;

  const orgResult = useMemo(() => {
    const res: ResType = {
      devProjectCount: null,
      yearProjectCount: null,
      businessOwner: null,
      status: null,
      platform: null,
      genre: null,
      dataTime: '',
    };
    const devProjectCountData = data?.project_counts,
          yearProjectCountData = data?.total_counts_of_launches,
          businessOwnerData = data?.business_owner,
          statusData = data?.status,
          platformData = data?.platform,
          genreData = data?.genre;
    // Total Project Counts In-Development
    if (devProjectCountData && Object.prototype.toString.call(devProjectCountData) === '[object Object]') {
      res.devProjectCount = {...FIXED_KEY_MAP};
      let total = 0;
      for (const key in devProjectCountData) {
        const tempKey = key?.trim()?.toLowerCase();
        if (typeof FIXED_KEY_MAP?.[tempKey] === 'number') {
          res.devProjectCount[tempKey] = res.devProjectCount[tempKey] + Number(devProjectCountData?.[key]) || 0;
        } else {
          res.devProjectCount['others'] = res.devProjectCount['others'] + Number(devProjectCountData?.[key]) || 0;
        }
        total = total + Number(devProjectCountData?.[key]) || 0;
      }
      res.devProjectCount['total'] = total;
    }
    // Total counts of launches next 12 months
    if (Array.isArray(yearProjectCountData) && yearProjectCountData?.length) {
      res.yearProjectCount = {
        'total': yearProjectCountData?.length,
        'list': getArraySort(yearProjectCountData, 'string', 'asc', 'launch_time')?.map((t: any) => ({...t, dateConfirm: t?.launch_date_confirm, date: t?.launch_time})),
      };
    }
    // Business Owner
    res.businessOwner = getArrayData(businessOwnerData);
    // Status
    res.status = getObjectData(statusData);
    // Platform
    res.platform = getArrayData(platformData);
    // Genre
    res.genre = getArrayData(genreData);
    // Data Time
    res.dataTime = data?.data_time || '';

    return res;
  }, [loading]);

  return orgResult;
};
